/* Shared purchase transport. Never navigate on failed/ambiguous cart mutations. */
(function (scope) {
  'use strict';
  async function addItems(items, options) {
    if (!items.length || items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isSafeInteger(item.quantity) || item.quantity < 1)) {
      throw new Error('Choose a valid product and quantity.');
    }
    const response = await options.fetch(options.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    let result;
    try { result = await response.json(); } catch (_) {
      throw new Error('We could not confirm the cart update. Open your cart before trying again.');
    }
    if (!result || typeof result !== 'object') {
      throw new Error('We could not confirm the cart update. Open your cart before trying again.');
    }
    if (!response.ok || result.status >= 400) {
      throw new Error((typeof result.description === 'string' && result.description) || 'This selection could not be added. Check your cart and available stock.');
    }
    if (!Array.isArray(result.items) || result.items.length !== items.length) {
      throw new Error('We could not confirm every item. Open your cart before trying again.');
    }
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { addItems };
  if (!scope.document || scope.SeoulRootCommerceLoaded) return;
  scope.SeoulRootCommerceLoaded = true;
  const doc = scope.document;
  const root = (scope.Shopify && scope.Shopify.routes && scope.Shopify.routes.root) || '/';
  const pending = new WeakSet();
  async function purchase(owner, button, items, checkout, status) {
    if (pending.has(owner)) return;
    pending.add(owner);
    const buttons = Array.from(owner.querySelectorAll('button[type="submit"], [data-sr-builder-submit], [data-sr-builder-item]'));
    const prior = buttons.map(el => el.disabled);
    buttons.forEach(el => { el.disabled = true; });
    owner.setAttribute('aria-busy', 'true');
    const loadingButton = button || buttons.find(el => !prior[buttons.indexOf(el)]);
    const priorLabel = loadingButton && loadingButton.getAttribute('aria-label');
    if (loadingButton) {
      loadingButton.setAttribute('data-sr-loading', '');
      loadingButton.setAttribute('aria-busy', 'true');
      loadingButton.setAttribute('aria-label', 'Adding to your cart');
    }
    // Keep progress inside the button; reserve the inline status for actionable errors.
    if (status) status.textContent = '';
    const tracking = {...scope.SeoulRootAnalytics?.context?.(owner), sr_item_count: items.reduce((sum, item) => sum + item.quantity, 0), sr_detail: owner.matches?.('[data-sr-routine]') ? 'routine_picker' : 'product_form'};
    scope.SeoulRootAnalytics?.send('sr_cart_attempt', tracking);
    try {
      await addItems(items, { root, fetch: scope.fetch.bind(scope) });
      scope.SeoulRootAnalytics?.send('sr_cart_success', tracking);
      if (checkout) scope.SeoulRootAnalytics?.send('sr_checkout_click', {...tracking, sr_detail: 'buy_now'});
      scope.location.assign(root + (checkout ? 'checkout' : 'cart'));
    } catch (error) {
      scope.SeoulRootAnalytics?.send('sr_cart_error', {...tracking, sr_detail: error instanceof TypeError ? 'network_error' : 'cart_update_failed'});
      if (status) {
        status.textContent = error instanceof TypeError ? 'Connection interrupted. Open your cart to check its contents before trying again.' : error.message;
        const link = doc.createElement('a');
        link.href = root + 'cart'; link.textContent = ' View cart';
        status.appendChild(link);
      }
      pending.delete(owner);
      buttons.forEach((el, i) => { el.disabled = prior[i]; });
      owner.removeAttribute('aria-busy');
      if (loadingButton) {
        loadingButton.removeAttribute('data-sr-loading');
        loadingButton.removeAttribute('aria-busy');
        if (priorLabel === null) loadingButton.removeAttribute('aria-label');
        else loadingButton.setAttribute('aria-label', priorLabel);
      }
    }
  }
  doc.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('[data-sr-product-form]')) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const values = new FormData(form);
    purchase(form, event.submitter, [{ id: Number(values.get('id')), quantity: Number(values.get('quantity') || 1) }], form.dataset.ordersEnabled === 'true' && event.submitter && event.submitter.name === 'checkout', form.querySelector('[data-sr-cart-status]'));
  });
  doc.querySelectorAll('[data-sr-selectable-routine]').forEach(owner => {
    const refresh = () => {
      const count = owner.querySelectorAll('[data-sr-builder-item]:checked:not(:disabled)').length;
      owner.querySelector('[data-sr-selection-count]').textContent = count ? count + (count === 1 ? ' product selected' : ' products selected') : 'Choose your products';
      const button = owner.querySelector('[data-sr-builder-submit]');
      button.disabled = count === 0 || pending.has(owner);
      button.textContent = count ? 'Add ' + count + (count === 1 ? ' product to cart' : ' products to cart') : 'Select a product';
    };
    owner.addEventListener('change', refresh);
    refresh();
  });
  doc.addEventListener('click', function (event) {
    const button = event.target.closest('[data-sr-builder-submit]');
    if (!button || button.disabled) return;
    const owner = button.closest('[data-sr-routine]');
    if (!owner) return;
    const items = Array.from(owner.querySelectorAll('[data-sr-builder-item]:checked:not(:disabled)')).map(el => ({ id: Number(el.value), quantity: 1 }));
    const status = owner.querySelector('[data-sr-builder-status]');
    if (!items.length) { if (status) status.textContent = 'Select at least one product to add to your cart.'; return; }
    purchase(owner, button, items, false, status);
  });
})(typeof window === 'undefined' ? {} : window);
